$(document).ready(function(){
	$('.feature-link').hover(function(){
		var target = $(this).attr("data-feature-link");
		$(".features-links").find(".active").removeClass("active");
		$(this).addClass("active");
		$(".features-lists").find(".active").removeClass("active");
		$(".lists").find("[data-list='" + target + "']").addClass("active");
		$(".features-images").find(".active").removeClass("active");
		$(".features-images").find("[data-image='" + target + "']").addClass("active");
		
	});
	$(".plan").click(function(){
		var target = $(this).attr("data-product");
		$(".plan").find(".selected").hide();
		$(".plan").removeClass("plan-selected");
		$(this).find(".selected").show();
		$(".next-button").attr("data-target", target);
		$(".questions").find(".question").hide();
		$(".questions").find("[data-question='" + target + "']").show();
		$(this).addClass("plan-selected");
		if (target == "fourth") {
			$(".questions").hide();
		}
	});
	$(".plans").find(".next-button").click(function(){
		var link = $(this).attr("data-target");
		if(link !== "fourth" && link !== "") {
			$(".questions").show();
          $('html,body').animate({
   scrollTop: $("#next-button").offset().top - 50
});
		}else if (link == "fourth"){
			var fourthlink = $(".without").attr("data-link");
			window.location = fourthlink;
		}
	});
	$( "select" ).change(function() {
  		var value = $(this).val();
  		var option = $(".questions").find("[value='" + value + "']").attr("data-link");
  		$(".final-button").attr("data-target", option).show();
	});
	$(".final-button").click(function(){
		var destination = $(this).attr("data-target");
		if (destination !== "") {
			window.location = destination;
		}
	});
});